<template>
  <!--个人信息-->
  <div class="user">
    <div class="user-div">
      <div class="distributionBox">
        <div class="title">
          <span class="address">{{ detailData.city }}</span>
          {{ detailData.title }}
        </div>
        <div class="personInformationBox">
          <div>
            <img class="headImg" src="../../assets/images/distribution/paihuo_touxiang_default.png"
                 v-if="!detailData.headImg">
            <img :src="detailData.headImg" v-else class="headImg" @click.stop="imagePreview(detailData.headImg)">
          </div>
          <div class="personInformation">
            <div class="name">{{ detailData.name }}
              <span class="iconImg common_tag_shiming" v-show="detailData.isAuth === 1"></span>
              <span class="iconImg common_tag_weishiming" v-show="detailData.isAuth === 0"></span>
            </div>
            <div class="information" v-for="(val, ind) in detailData.datas" :key="ind"
                 v-if="val.id !== 'score'">
              <span>{{ val.key }}： </span>
              {{ val.value }}
            </div>
          </div>
        </div>
        <div class="WRAST" v-for="(val, ind) in detailData.datas" :key="ind" v-if="val.id === 'score'">
          <span class="text">{{ val.key }}：</span>
          <span class="WRASText" v-if="val.value.socreLevel == -1">黑名单</span>
          <span class="WRASText" v-if="val.value.socreLevel == 0">信用未评级</span>
          <img src="../../assets/images/distribution/star_one.png" class="star_one"
               v-if="val.value.starCount === 1">
          <img src="../../assets/images/distribution/star_two.png" class="star_two"
               v-if="val.value.starCount === 2">
          <img src="../../assets/images/distribution/star_three.png" class="star_three"
               v-if="val.value.starCount === 3">
          <img src="../../assets/images/distribution/star_four.png" class="star_four"
               v-if="val.value.starCount === 4">
          <img src="../../assets/images/distribution/star_five.png" class="star_five"
               v-if="val.value.starCount === 5">
        </div>
      </div>
      <div class="distributionBox" v-if="detailData.detailDatas.length>0">
        <div class="box" v-for="(item, index) in detailData.detailDatas" :key="index">
          <div class="title" style="font-weight: bold">{{ item.key }}</div>
          <div class="title">{{ item.value }}</div>
        </div>
      </div>
    </div>

    <div class="bottom-btn" v-if="type == 1">
      <van-button class="van-button-1" color="#37A1FFFF" round @click="callPhone" block>拨打电话</van-button>
      <van-button class="van-button-2" color="#096CEFFF" round @click="agreeAccept" block>同意签约</van-button>
    </div>

    <div class="bottom-btn" v-if="type == 2 && ((status == 6 && finishAssessStatus == 0) || assessStatus == 2)" >
      <van-button color="#096CEFFF" round @click="toFinishAssess" block>完工评价</van-button>
    </div>

    <div class="btn-div" v-if="type == 2">
      <van-button class="btn-1" color="#096CEFFF" round type="primary" plain
                  v-if="status !== 6 && detailData.isFinish == 0"
                  @click="simpleFinish">
        完工
      </van-button>
      <van-button class="btn-2" round color="#37A1FFFF" type="primary"
                  v-if="status !== 6 && detailData.isFinish == 0"
                  @click="tellPhone(detailData.mobile)">拨打电话
      </van-button>
      <van-button  class="btn-3" round  color="#096CEFFF" type="primary"
                   v-if="assessStatus == 1"
                  @click="toEvaluate">中期评价
      </van-button>
    </div>

    <div class="paddingBottom60"></div>
    <imagePopup v-model="showImagePopup" :imgUrl="imgUrl"/>
  </div>

</template>

<script>
import {
  agreeAccept,
  getAcceptDetail,
  getSignDetail,
  simpleFinish,
  getMidAssessStatus,
  getFinishAssessStatus
} from '@api/project'
import imagePopup from '@components/imagePopup/imagePopup'
import { callByCoin, onceCallCoins } from '@api/integralMall'

export default {
  name: 'user',
  components: {
    imagePopup
  },
  data () {
    return {
      status: '',
      unitId: '',
      detailData: {},
      assessStatus: '',
      finishAssessStatus: '',
      showImagePopup: false,
      imgUrl: ''
    }
  },
  created () {
    this.joinId = this.$route.query.joinId
    this.projectId = this.$route.query.projectId
    this.type = this.$route.query.type
    this.status = this.$route.query.status
    this.unitId = this.$route.query.unitId
    if (this.type == 1) {
      // 获取报名信息
      this.getSignDetail()
    } else {
      // 获取签约信息
      this.getAcceptDetail()
      // 获取评价状态
      if (this.status == 6) {
        // 获取项目是否已完工评价
        this.getFinishAssessStatus()
      } else {
        // 获取是否中期评价
        this.getMidAssessStatus()
      }
    }
    // 初始化极光统计
    this.$jiguang.initCountEvent()
  },

  mounted () {
    // 支付回调
    this.$bridge.registerHandler('paySuccess', (data, responseCallback) => {
      this.payment()
    })
  },

  methods: {
    // 获取是否中期评价
    getMidAssessStatus () {
      getMidAssessStatus({ projectId: this.projectId, unitId: this.joinId }).then(res => {
        if (res.data.code === 200) {
          this.assessStatus = res.data.data.assessStatus
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },
    // 获取项目是否已完工评价
    getFinishAssessStatus () {
      getFinishAssessStatus({ projectId: this.projectId, unitId: this.joinId }).then(res => {
        if (res.data.code === 200) {
          this.finishAssessStatus = res.data.data.assessStatus
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },

    // 签约后拨打电话（直接拨打电话号码）
    tellPhone (phone) {
      const data = { phone: phone }
      this.$bridge.callHandler('callPhone', data, response => {
        console.log('response:', response)
      })
    },

    // 调用拨号功能
    callPhone () {
      onceCallCoins({
        dataType: 4,
        dataId: this.joinId,
        dataIdAdd: this.projectId
      }).then(res => {
        if (res.data.code === 200) {
          if (res.data.data.firstFlag === true) {
            // 获取极光统计所需数据
            this.$bridge.callHandler('getDeviceInfo', 'callPhone_alert', response => {
              console.log('response:', response)
            })

            this.$dialog.confirm({
              title: '拨打电话',
              message:
                `拨打电话，需要支付${res.data.data.value}个邀工币。`,
              confirmButtonColor: '#096CEFFF'
            })
              .then(() => {
                this.payment()
              })
              .catch(() => {
                // on cancel
              })
          } else {
            callByCoin({
              dataType: 4,
              dataId: this.joinId,
              dataIdAdd: this.projectId
            }).then(res => {
              if (res.data.code === 200) {
                const phoneNumber = res.data.data.phone
                const data = { phone: phoneNumber }
                this.$bridge.callHandler('callPhone', data, response => {
                  console.log('response:', response)
                })
              }
            })
          }
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },
    payment () {
      callByCoin({
        dataType: 4,
        dataId: this.joinId,
        dataIdAdd: this.projectId
      }).then(res => {
        if (res.data.code === 200) {
          // 判断邀功币不足
          if (res.data.data.enough == 0) {
            const data = {
              title: '邀工币充值',
              url: `${process.env.VUE_APP_BASE_HOST}/coinsPay?coinRemain=` + res.data.data.coinRemain + '&coinNeed=' + res.data.data.coinNeed
            }
            this.$bridge.callHandler('newPage', data, response => {
              console.log('response:', response)
            })
          } else {
            const phoneNumber = res.data.data.phone
            this.$dialog.confirm({
              title: '拨打电话',
              message:
                '支付完成，您可以拨打电话',
              confirmButtonColor: '#096CEFFF'
            })
              .then(() => {
                // 获取极光统计所需数据
                this.$bridge.callHandler('getDeviceInfo', 'callPhone_alert_confirm', response => {
                  console.log('response:', response)
                })

                const data = { phone: phoneNumber }
                this.$bridge.callHandler('callPhone', data, response => {
                  console.log('response:', response)
                })
              })
              .catch(() => {
                // on cancel
              })
          }
        } else {
          this.$toastMsg(res.data.msg)
        }

      })

    },
    // 获取报名信息
    getSignDetail () {
      getSignDetail({
        joinId: this.joinId,
        projectId: this.projectId
      }).then(res => {
        if (res.data.code === 200) {
          this.detailData = res.data.data
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },
    // 获取签约信息
    getAcceptDetail () {
      getAcceptDetail({
        joinId: this.joinId,
        projectId: this.projectId
      }).then(res => {
        if (res.data.code === 200) {
          this.detailData = res.data.data
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },

    // 完工
    simpleFinish () {
      simpleFinish({
        joinId: this.joinId,
        projectId: this.projectId
      }).then(res => {
        if (res.data.code === 200) {
          this.$toast.success('操作成功')
          // 延迟1秒
          setTimeout(() => {
            this.$bridge.callHandler('backRefresh', response => {
              console.log('response:', response)
            })
          }, 1000)
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },
    // 同意签约
    agreeAccept () {
      agreeAccept({
        joinId: this.joinId,
        projectId: this.projectId
      }).then(res => {
        if (res.data.code === 200) {
          this.$toast.success('操作成功')
          // 延迟1秒
          setTimeout(() => {
            this.$bridge.callHandler('backRefresh', response => {
              console.log('response:', response)
            })
          }, 1000)
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },
    // 跳转完工评价
    toFinishAssess () {
      // this.enterRouter('appraise', {projectId: this.projectId, unitId: this.joinId})
      // 客户端跳转
      const data = {
        title: '完工评价',
        url: `${process.env.VUE_APP_BASE_HOST}/appraise?projectId=${this.projectId}&unitId=${this.joinId}`
      }
      this.$bridge.callHandler('newPage', data, response => {
        console.log('response:', response)
      })
    },
    // 跳转中期评价页面
    toEvaluate () {
      // this.enterRouter('midProjectEvaluation', {projectId: this.projectId, unitId: this.joinId})
      // 客户端跳转
      const data = {
        title: '中期评价',
        url: `${process.env.VUE_APP_BASE_HOST}/midProjectEvaluation?projectId=${this.projectId}&unitId=${this.joinId}`
      }
      this.$bridge.callHandler('newPage', data, response => {
        console.log('response:', response)
      })
    },
    imagePreview (imgUrl) {
      this.showImagePopup = true
      this.imgUrl = imgUrl
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/css/mixin";

.paddingBottom60 {
  height: 10px;
}

.user {
  padding-bottom: 120px;
  position: relative;
}

.user-div {
  .headImg {
    width: 68px !important;
    height: 68px !important;
    border-radius: 5px;
    margin-right: 10px;
  }
}

.btn-div {
  text-align: center;
  position: fixed;
  bottom: 20px;
  width: 100%;

  .van-button {
    margin: 0 5px;
    font-size: 17px;
    height: 40px;
    line-height: 40px;
  }

  .btn-1 {
    width: 30%;
  }

  .btn-2 {
    width: 30%;
  }

  .btn-3 {
    width: 30%;
  }
}

</style>
